import {
  ModalManager,
  useModal,
} from "@circle-react/components/Layout/ModalManagerProvider";
import { AddFileModalComponent } from "./AddFileModalComponent";

const AddFileModal = ModalManager.create(() => <AddFileModalComponent />);

export const useAddFileModal = () => useModal(AddFileModal);
